module.exports = __webpack_public_path__ + "img/Belarus.83d54fa1.png";